import { StateCreator } from 'zustand';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { ProjectStore } from './types';

export const createProjectSlice: StateCreator<ProjectStore> = (set) => ({
  selectedProjectId: localStorage.getItem(LOCAL_STORAGE_KEYS.SELECTED_PROJECT_ID),
  setSelectedProjectId: (projectId: string) => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.SELECTED_PROJECT_ID, projectId);
    set({ selectedProjectId: projectId });
  },
});
